export default __webpack_public_path__ + "static/media/transferred-icon.2310bc8c.svg";